import React from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import TemplateCreation from '../../TemplateCreation'
import Modal from '../../../UniformComponents/Modal'
import ModalHeader from '../../../UniformComponents/ModalHeader'

const PageTemplate = observer((props) => {
    const { store } = props
    const { survey } = store

    const hideTemplateCreation = () => {
        store.showTemplateCreation = false
        store.templateCreationPageId = null
    }

    return (
        <Modal show={store.showTemplateCreation} enforceFocus onClose={hideTemplateCreation}>
            <ModalHeader>
                <h2>{i18n.t('surveyBuilder.modal.template.title')}</h2>
            </ModalHeader>
            <div
                className="body"
                style={{
                    overflow: 'auto',
                    minHeight: '400px',
                }}
            >
                <TemplateCreation survey={survey} store={store} onClose={hideTemplateCreation} {...props} />
            </div>
        </Modal>
    )
})

export default PageTemplate
